import { render, staticRenderFns } from "./apidoc.vue?vue&type=template&id=5f52cc3a"
import script from "./apidoc.vue?vue&type=script&lang=ts"
export * from "./apidoc.vue?vue&type=script&lang=ts"
import style0 from "./apidoc.vue?vue&type=style&index=0&id=5f52cc3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports